// Небольшой зависимость-независимый WebSocket-клиент, заменяющий vue-pusher
// (см. ANALYSIS.md, часть B, и backend-часть lib/ws.js). Подключается к
// тому же хосту/порту, что и REST API (VUE_APP_PATH из vue/.env), меняя
// схему http(s) -> ws(s) и добавляя путь /ws.
const PATH = process.env.VUE_APP_PATH

// В продакшен-сборке VUE_APP_PATH пустой — берём origin страницы: относительный
// URL ('/ws') в new WebSocket() принимают только свежие браузеры, а старые
// (Android WebView, старый Safari/Chromium) бросают исключение и loadData падает.
function wsUrl() {
  const base = PATH || window.location.origin
  return base.replace(/^https/, 'wss').replace(/^http/, 'ws') + '/ws'
}

// connect(login, passwordAES) -> { on(event, cb), close() }
// Сразу после открытия соединения отправляет {login, passwordAES} — тот же
// auth-хендшейк, что ожидает backend (lib/ws.js). Переподключается
// автоматически с экспоненциальным (капнутым) бэкоффом, пока close() не
// вызван явно.
export function connect(login, passwordAES) {
  const listeners = {}
  let socket = null
  let closedByUser = false
  let attempt = 0
  let reconnectTimer = null

  function emit(event, payload) {
    (listeners[event] || []).forEach(cb => cb(payload))
  }

  function open() {
    socket = new WebSocket(wsUrl())

    socket.addEventListener('open', () => {
      attempt = 0
      socket.send(JSON.stringify({ login, passwordAES }))
    })

    socket.addEventListener('message', (event) => {
      try {
        const msg = JSON.parse(event.data)
        emit(msg.event, msg.payload)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('ws: не удалось разобрать сообщение сервера', err)
      }
    })

    socket.addEventListener('close', () => {
      if (closedByUser) return
      attempt += 1
      const delay = Math.min(1000 * attempt, 10000)
      reconnectTimer = setTimeout(open, delay)
    })

    // 'error' всегда сопровождается последующим 'close' в браузерном
    // WebSocket API — переподключение обрабатывается там.
    socket.addEventListener('error', () => {})
  }

  open()

  return {
    on(event, cb) {
      if (!listeners[event]) listeners[event] = []
      listeners[event].push(cb)
    },
    close() {
      closedByUser = true
      if (reconnectTimer) clearTimeout(reconnectTimer)
      if (socket) socket.close()
    },
  }
}
